import dashboard from './dashboard.js';
import sidebar from './sidebar.js';
import button from './button.js';
import transcript from './transcript.js';
import form from './forms';

export default {
    dashboard: 'Dashboard',
    noRecord: 'No record found.',
    filters: 'Filters',
    noFiles: 'No files.',
    pageNotFound: 'Error 404 - Page not found',
    leavePrompt: 'There are unsaved changes. Are you sure you want to continue?',

    app: {
        name: 'SBS Swiss Business School'
    },

    login: {
        loginText: 'Sign in to start your session',
        username: 'Username',
        password: 'Password',
        recoveryKey: 'Please save Recovery Key={key} that will be asked if you lost or need to change device for 2FA.',
        invalid: 'The user credentials were incorrect.',
    },

    footer: {
        text: '<strong>Copyright &copy; {year} <a href="{url}">{name}</a>.</strong> All rights reserved.',
        version: '<b>Version</b>: WebSMS'
    },

    google2fa: {
        heading: 'Two Factor Authentication',
        enterPinText: 'Enter the OTP from Authenticator App',
        recoveryKey: 'Recovery Key'
    },

    dashboard,
    sidebar,
    button,
    form,
    transcript,
};
